var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiRrSignalAlt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi-rr-signal-alt",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5260",
    "data-name": "Path 5260",
    d: "M11.5,6A2.5,2.5,0,0,0,9,8.5v10a2.5,2.5,0,0,0,5,0V8.5A2.5,2.5,0,0,0,11.5,6Zm.833,12.5a.833.833,0,0,1-1.667,0V8.5a.833.833,0,1,1,1.667,0Z",
    transform: "translate(-1.5 -1)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5261",
    "data-name": "Path 5261",
    d: "M20.5,0A2.5,2.5,0,0,0,18,2.5v15a2.5,2.5,0,0,0,5,0V2.5A2.5,2.5,0,0,0,20.5,0Zm.833,17.5a.833.833,0,0,1-1.667,0V2.5a.833.833,0,1,1,1.667,0Z",
    transform: "translate(-3)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5262",
    "data-name": "Path 5262",
    d: "M2.5,12A2.5,2.5,0,0,0,0,14.5v5a2.5,2.5,0,1,0,5,0v-5A2.5,2.5,0,0,0,2.5,12Z",
    transform: "translate(0 -2)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrSignalAlt);
export default __webpack_public_path__ + "static/media/fi-rr-signal-alt.33859c94.svg";
export { ForwardRef as ReactComponent };